// ✅ Cleaned version of all three components will be pasted in three steps
// First: facets.js

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 300);

    const form = this.querySelector('form');
    form.addEventListener('input', this.debouncedOnSubmit);
  }

  static setListeners() {
    window.addEventListener('popstate', (event) => {
      const searchParams = event.state?.searchParams || FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.querySelector('#ProductGridContainer .collection')?.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      fetch(url)
        .then(res => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          console.log('[facets] fetched section:', section.section, html);
          FacetFiltersForm.renderFilters(doc);
          FacetFiltersForm.renderProductGridContainer(doc);
          FacetFiltersForm.renderProductCount(doc);
          document.dispatchEvent(new Event('facets:updated'));
        });
    });

    if (updateURLHash) {
      history.pushState({ searchParams }, '', `${window.location.pathname}?${searchParams}`);
    }
  }

static renderFilters(doc) {
  const newFilters = doc.querySelectorAll('#FacetFiltersFormMobile .js-filter');
  const currentFilters = document.querySelectorAll('#FacetFiltersFormMobile .js-filter');

  newFilters.forEach((newEl, index) => {
    const currentEl = currentFilters[index];
    if (currentEl && newEl) {
      // Preserve show more button state before replacing
      const currentButton = currentEl.querySelector('.show-more-fallback');
      const currentList = currentEl.querySelector('.mobile-facets__list');
      const wasExpanded = currentList && !currentList.classList.contains('height-adjust');
      const buttonText = currentButton?.textContent;

      currentEl.innerHTML = newEl.innerHTML;

      // Restore show more button state after replacing
      const newButton = currentEl.querySelector('.show-more-fallback');
      const newList = currentEl.querySelector('.mobile-facets__list');
      if (newButton && newList && currentButton) {
        newButton.style.display = 'flex';
        newButton.setAttribute('data-initialized', 'true');
        if (wasExpanded) {
          newList.classList.remove('height-adjust');
          newList.style.maxHeight = 'none';
          newButton.textContent = 'SHOW LESS';
        } else {
          newList.classList.add('height-adjust');
          newList.style.maxHeight = '150px';
          newList.style.overflow = 'hidden';
          newButton.textContent = 'SHOW MORE';
        }
      }
    }
  });

  const activeFacets = doc.querySelector('.active-facets-mobile');
  if (activeFacets) {
    document.querySelector('.active-facets-mobile').innerHTML = activeFacets.innerHTML;
  }
}

 static renderProductGridContainer(doc) {
  const newGrid = doc.getElementById('ProductGridContainer');
  const existingGrid = document.getElementById('ProductGridContainer');

  if (newGrid && existingGrid) {
    existingGrid.innerHTML = newGrid.innerHTML;
  } else {
    console.warn('ProductGridContainer not found in one of the documents');
  }
}

static renderProductCount(doc) {
  const ids = ['ProductCount', 'ProductCountDesktop'];

  ids.forEach((id) => {
    const newCount = doc.getElementById(id);
    const existing = document.getElementById(id);

    console.log(`[facets] update triggered for ${id}`);
    console.log('newCount:', newCount?.textContent);
    console.log('existing:', existing);

    if (newCount && existing) {
      existing.innerHTML = newCount.innerHTML;
    }
  });
}

static getSections() {
  return [
    { section: 'main-collection-product-grid' },
    { section: 'main-collection-banner' }
  ];
}

  createSearchParams(form) {
  const formData = new FormData(form);
  const searchParams = new URLSearchParams(formData);

  const currentParams = new URLSearchParams(window.location.search);
  if (currentParams.get('sort_by')) {
    searchParams.set('sort_by', currentParams.get('sort_by'));
  }

  return searchParams.toString();
}

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const searchParams = this.createSearchParams(form);
    this.onSubmitForm(searchParams, event);
  }

  onActiveFilterClick(event) {
  event.preventDefault();
  const url = new URL(event.currentTarget.href, window.location.origin);

  const currentSort = new URLSearchParams(window.location.search).get('sort_by');
  if (currentSort) {
    url.searchParams.set('sort_by', currentSort);
  }

  FacetFiltersForm.renderPage(url.searchParams.toString());
}
}

FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', this.validate.bind(this));
    });
  }

  validate(e) {
    const min = parseFloat(this.querySelector('input[min]')?.value || 0);
    const max = parseFloat(this.querySelector('input[max]')?.value || 99999);
    e.target.value = Math.max(min, Math.min(max, parseFloat(e.target.value)));
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    link.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('facet-filters-form')?.onActiveFilterClick(e);
    });
  }
}
customElements.define('facet-remove', FacetRemove);